<template>
    <div>
        <leisures-component/>
        <footer-component/>
    </div>
</template>

<script>
    import LeisuresComponent from "@/components/restaurants-leisures/LeisuresComponent";
    import FooterComponent from "@/layouts/app-layout/footer/FooterComponent";
    
    export default {
        name: "Leisures",
        title: "Lugares y Ocio | Turismo BC",
        components: {
            LeisuresComponent,
            FooterComponent
        }
    }
</script>

<style scoped>

</style>